/**
 * Build the upload-page link that carries the drug name and the source page.
 * Plain module (no 'use client') so server components can call it.
 *
 * The values go in the URL fragment, not the query string, so analytics never
 * record which medicine a visitor asked about (see src/lib/upload-handoff.ts).
 */
import { uploadHref } from './upload-handoff';

export function requestHref(drugName: string, source: string, pet = false): string {
  return uploadHref({ medication: drugName, src: source, pet: pet && '1' });
}

/** Upload-page link with no medication filled in, for pages about a topic rather than one drug. */
export function requestHrefGeneric(source: string, pet = false): string {
  return uploadHref({ src: source, pet: pet && '1' });
}
